/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from "react";
// ** Cutome Component
import Breadcrumbs from "@components/breadcrumbs";
import { Button, Card, Col, Row, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { Check, Edit, Plus, Trash } from "react-feather";
import Select from "react-select";

import { selectThemeColors } from "@utils";

import LineSkelaton from "../../../common/skeleton/LineSkelaton";
import ReactPaginate from "react-paginate";
import { PerPaginationPageData } from "../../../constant/constant";
import ConfirmModel from "../../components/modals/ConfirmModal";
// import { deleteDiscountCoupon } from "../../../services/discountCouponService";
// import { getErrorMsg } from "../../../common/ErrorMessages/errorMessage";
// import toast from "react-hot-toast";
import ToastContent from "../../components/toast/toast";

import AddDiscountModel from "../discountCoupon/AddDiscountModel";
import AddNewEditor from "./PopUp/AddNewEditor";
import {
  getEditorMaster,
  getEditors,
} from "../../../redux/editorsMaster/editorsMaster.thunk";
import { assignEditorsMaster } from "../../../services/EditorsMaster/editorsMaster.services";
import toast from "react-hot-toast";
import { getErrorMsg } from "../../../common/ErrorMessages/errorMessage";

const Next = () => {
  return <span className="align-middle d-none d-md-inline-block">Next </span>;
};

const Previous = () => {
  return <span className="align-middle d-none d-md-inline-block">Prev</span>;
};

const EditorsMaster = () => {
  const dispatch = useDispatch();
  const [editorModel, setEditorModel] = useState({
    isOpen: false,
    isReApiCall: false,
  });

  // const [currentPage, setCurrentPage] = useState(0);

  const editorsMaster = useSelector((state) => state.editorsMaster);

  const handleEditorAssigned = (value, company_id) => {
    const payload = {
      company_id,
      editor_id: value.id,
    };

    assignEditorsMaster(payload)
      .then((res) => {
        toast((t) => (
          <ToastContent
            t={t.id}
            message={res?.message}
            icon={<Check size={12} />}
            color="success"
          />
        ));
      })
      .catch((err) => {
        console.log("err: ", err);
        getErrorMsg(err);
      });
  };

  useEffect(() => {
    dispatch(getEditors());
    dispatch(getEditorMaster());
  }, []);
  return (
    <>
      <div className="w-100 d-flex justify-content-end mb-1">
        <Button.Ripple
          color="primary"
          onClick={() => {
            setEditorModel({ ...editorModel, isOpen: true });
          }}
        >
          <Plus size={14} />
          <span className="align-middle ms-25">Add a New Editor</span>
        </Button.Ripple>
      </div>
      <div>
        <Table hover>
          <thead>
            <tr>
              {/* <th>Sr. No.</th> */}
              <th>Company Name</th>
              <th>Editors Name</th>
            </tr>
          </thead>
          <tbody>
            {editorsMaster?.editorsMasterList?.data?.map((row) => (
              <tr key={row.company_id}>
                {/* <td>{row.sr_no}</td> */}
                <td
                  className={`fw-bolder ${
                    row?.is_subscriber === 1 ? "table-custom-column" : ""
                  }`}
                >
                  {row.company_name}
                </td>
                <td className="fw-bolder " key={row.company_id}>
                  <Select
                    menuPortalTarget={document.body}
                    id="editor"
                    placeholder="Select"
                    className="react-select custom-table-react-se"
                    classNamePrefix="select"
                    isClearable={false}
                    options={editorsMaster?.editorsList?.data}
                    theme={selectThemeColors}
                    getOptionValue={(opt) => opt.id}
                    getOptionLabel={(opt) => opt.editor_name}
                    // defaultValue={}
                    defaultValue={editorsMaster?.editorsList?.data.find(
                      (item) => item.id === row.editor_id
                    )}
                    onChange={(e) => handleEditorAssigned(e, row.company_id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="no_data">
          {editorsMaster?.editorsMasterList?.isFetching === false &&
            editorsMaster?.editorsMasterList?.data?.data?.data?.length ===
              0 && (
              <Card>
                <p>No Data are found</p>
              </Card>
            )}
          {editorsMaster?.editorsMasterList?.isFetching === true && (
            <div>
              {[...Array(5)].map((_, i) => (
                <LineSkelaton key={i} />
              ))}
            </div>
          )}
        </div>
      </div>
      {/* <div className="d-flex justify-content-end">
        <ReactPaginate
          //   pageCount={calculatePagesCount(
          //     PerPaginationPageData,
          //     editorsMaster?.editorsMasterList?.data?.data?.total
          //   )}
          breakLabel="..."
          nextLabel={<Next />}
          pageRangeDisplayed={1}
          marginPagesDisplayed={2}
          activeClassName="active"
          pageClassName="page-item"
          breakClassName="page-item"
          previousLabel={<Previous />}
          nextLinkClassName="page-link"
          pageLinkClassName="page-link"
          nextClassName="page-item next"
          breakLinkClassName="page-link"
          previousClassName="page-item prev"
          previousLinkClassName="page-link"
          containerClassName={`pagination react-paginate ${
            (editorsMaster?.editorsMasterList?.isFetching === true ||
              editorsMaster?.editorsMasterList?.data?.data?.data?.length ===
                0) &&
            "d-none"
          }`}
          onPageChange={(page) => handlePagination(page)}
          forcePage={currentPage}
        />
      </div> */}
      {/* {editorModel.isOpen && ( */}
      <AddNewEditor
        editorModel={editorModel}
        setEditorModel={setEditorModel}
        isModelUseFor="ADD"
        // setCurrentPage={setCurrentPage}
      />
      {/* )} */}
    </>
  );
};

export default EditorsMaster;
